/* Kinect x LACES: color-family swatches on product cards.
   Swatch buttons are rendered by snippets/k-card-swatches.liquid from custom.sibling_products;
   this script colors them from the colorway in the title and swaps the card on hover/click. */
(() => {
  const COLORS = {
    black: '#151515', white: '#f7f7f5', offwhite: '#ece6d8', cream: '#efe7d2', ube: '#7d5fa8', purple: '#6b4fa0',
    blue: '#2f5fb3', navy: '#1f2a44', bolt: '#1e88e5', gold: '#d4a72c', red: '#b3262e', poppy: '#e0463a',
    orange: '#e8742b', green: '#2f5d3a', tan: '#c9ae86', mocha: '#7a5a45', greige: '#b8ae9f',
    gray: '#9a9a9a', grey: '#9a9a9a', heathergray: '#a9a9ab', pink: '#e8a3b5', brown: '#6b4a32'
  };
  const PAIRS = { 'off white': 'offwhite', 'heather gray': 'heathergray', 'heather grey': 'heathergray', 'poppy red': 'poppy', 'bolt blue': 'bolt' };

  const colorsFrom = (title) => {
    let t = title.toLowerCase().replace(/off-white/g, 'off white');
    Object.entries(PAIRS).forEach(([k, v]) => { t = t.split(k).join(v); });
    const words = t.replace(/[^a-z ]+/g, ' ').trim().split(/\s+/);
    const out = [];
    for (let i = words.length - 1; i >= 0 && COLORS[words[i]]; i--) out.unshift(words[i]);
    return out;
  };

  const paint = (btn) => {
    const hex = colorsFrom(btn.dataset.title || '').map((c) => COLORS[c]);
    if (hex.length === 1) btn.style.background = hex[0];
    else if (hex.length > 1) btn.style.background = `linear-gradient(135deg, ${hex[0]} 0 50%, ${hex[1]} 50% 100%)`;
    else if (btn.dataset.thumb) btn.style.background = `#eee url("${btn.dataset.thumb}") center / cover`;
  };

  const swap = (card, btn) => {
    card.querySelectorAll('a.product-link, a.quickbuy-toggle').forEach((a) => { a.href = btn.dataset.url; });
    const title = card.querySelector('.product-block__title');
    if (title) title.textContent = btn.dataset.title;
    const img = card.querySelector('.product-block__image--primary img, .image-cont img');
    if (img && btn.dataset.img) {
      if (!img.dataset.kOrigSrc) { img.dataset.kOrigSrc = img.currentSrc || img.src; img.dataset.kOrigSrcset = img.srcset || ''; }
      if (btn.classList.contains('k-swatch--origin')) {
        img.src = img.dataset.kOrigSrc; if (img.dataset.kOrigSrcset) img.srcset = img.dataset.kOrigSrcset;
      } else { img.removeAttribute('srcset'); img.src = btn.dataset.img; }
    }
    const price = card.querySelector('.product-price--block');
    if (price && btn.dataset.price !== undefined) price.innerHTML = btn.dataset.price;
    const labels = card.querySelector('.k-label-slot');
    if (labels && btn.dataset.label !== undefined) labels.innerHTML = btn.dataset.label;
    const rating = card.querySelector('.k-rating-slot');
    if (rating && btn.dataset.rating !== undefined) rating.innerHTML = btn.dataset.rating;
    const badges = card.querySelector('.k-badge-slot');
    if (badges && btn.dataset.badges !== undefined) badges.innerHTML = btn.dataset.badges;
    const qa = card.querySelector('.k-quick-add');
    if (qa && btn.dataset.variant !== undefined) {
      const available = btn.dataset.available === 'true';
      const direct = available && btn.dataset.single === 'true';
      const input = qa.querySelector('input[name="id"]');
      if (input) input.value = btn.dataset.variant;
      qa.querySelector('.k-quick-add__form').hidden = !direct;
      const link = qa.querySelector('.k-quick-add__link');
      link.hidden = direct;
      link.href = btn.dataset.url;
      link.textContent = available ? 'Choose options' : 'Sold out';
    }
    card.querySelectorAll('.k-swatch').forEach((s) => s.classList.toggle('k-swatch--active', s === btn));
  };

  const init = (root) => {
    root.querySelectorAll('.k-swatches:not([data-k-ready])').forEach((wrap) => {
      wrap.dataset.kReady = '1';
      const card = wrap.closest('product-block');
      wrap.querySelectorAll('.k-swatch').forEach((btn) => {
        paint(btn);
        if (btn.classList.contains('k-swatch--active')) btn.classList.add('k-swatch--origin');
        if (!card) return;
        btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); swap(card, btn); });
        btn.addEventListener('mouseenter', () => swap(card, btn));
      });
    });
  };

  const start = () => {
    init(document);
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => init(document), 100); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Kinect x LACES: third-party UI coordination.
   - Mobile: hold the Klaviyo popup (CSS in kinect-haus.css) until the shopper has scrolled 1.5 screens or 20s pass, once per session.
   - Mark the Vitals reviews widget empty when it has 0 reviews (fallback for browsers without :has()). */
(() => {
  const root = document.documentElement;
  const KEY = 'kPopupsReleased';
  let released = false;
  try { released = sessionStorage.getItem(KEY) === '1'; } catch (e) { released = true; }
  if (!released && window.matchMedia('(max-width: 767.98px)').matches) {
    root.classList.add('k-hold-popups');
    let timer;
    const release = () => {
      root.classList.remove('k-hold-popups');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* private mode */ }
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
    };
    const onScroll = () => { if (window.scrollY > window.innerHeight * 1.5) release(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    timer = setTimeout(release, 20000);
  }

  const markEmptyReviews = () => {
    document.querySelectorAll('.vtl-pr-main-widget:not(.k-reviews-empty)').forEach((w) => {
      if (w.querySelector('.vtl-pr-stats--no-reviews, .vtl-pr-main-widget__summary-no-reviews')) w.classList.add('k-reviews-empty');
    });
  };
  const start = () => {
    markEmptyReviews();
    const end = document.getElementById('vitals-end-section');
    const observer = new MutationObserver(() => {
      markEmptyReviews();
      if (!end && document.querySelector('.vtl-pr-main-widget .vtl-pr-stats, .vtl-pr-main-widget__summary-no-reviews')) observer.disconnect();
    });
    observer.observe(end || document.body, { childList: true, subtree: true });
    if (!end) setTimeout(() => observer.disconnect(), 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// Mega-menu hover preview: hovering a dropdown link shows its photo (over the promo tiles, or beside a small menu)
(() => {
  document.querySelectorAll('#main-nav .k-nav-preview').forEach((stage) => {
    const ul = stage.parentElement;
    const links = [...ul.querySelectorAll('a.navigation__link')];
    const withImg = links.filter((a) => a.dataset.kPreview);
    const side = stage.classList.contains('k-nav-preview--side');
    const promos = ul.querySelectorAll(':scope > .navigation__column--promotion');
    if (!withImg.length || (!side && !promos.length)) {
      ul.closest('.k-small-preview')?.classList.remove('k-small-preview');
      stage.remove();
      return;
    }
    const link = stage.querySelector('a');
    const img = stage.querySelector('img');
    const title = stage.querySelector('.k-nav-preview__title');
    const place = () => {
      const first = promos[0];
      const last = promos[promos.length - 1];
      const left = first.offsetLeft + parseFloat(getComputedStyle(first).paddingLeft);
      const right = last.offsetLeft + last.offsetWidth - parseFloat(getComputedStyle(last).paddingRight);
      Object.assign(stage.style, { left: `${left}px`, top: `${first.offsetTop}px`, width: `${right - left}px`, height: `${first.querySelector('.menu-promotion')?.offsetHeight || first.offsetHeight}px` });
    };
    const set = (a) => {
      if (img.getAttribute('src') !== a.dataset.kPreview) img.src = a.dataset.kPreview;
      stage.dataset.fit = a.dataset.kPreviewFit || 'contain';
      title.textContent = a.textContent.trim();
      link.href = a.href;
    };
    const show = (a) => {
      if (!side) place();
      set(a);
      ul.classList.add('k-previewing');
    };
    const reset = () => (side ? set(withImg[0]) : ul.classList.remove('k-previewing'));
    if (side) set(withImg[0]);
    links.forEach((a) => {
      const handler = a.dataset.kPreview ? () => show(a) : reset;
      a.addEventListener('mouseenter', handler);
      a.addEventListener('focus', handler);
    });
    ul.addEventListener('mouseleave', reset);
    ul.addEventListener('focusout', (e) => { if (!ul.contains(e.relatedTarget)) reset(); });
    ul.addEventListener('mouseenter', () => {
      withImg.forEach((a) => { new Image().src = a.dataset.kPreview; });
    }, { once: true });
  });
})();
